var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { attachKey2click, ReactElementFactory, SurveyElementBase, SvgIcon } from "survey-react-ui";
import { SurveyCreatorToolboxTool } from "./ToolboxItem";
var SurveyCreatorToolboxCategory = /** @class */ (function (_super) {
    __extends(SurveyCreatorToolboxCategory, _super);
    function SurveyCreatorToolboxCategory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyCreatorToolboxCategory.prototype, "category", {
        get: function () {
            return this.props.category;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorToolboxCategory.prototype, "toolbox", {
        get: function () {
            return this.props.toolbox;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorToolboxCategory.prototype, "class", {
        get: function () {
            return "svc-toolbox__category" +
                (this.category.collapsed ? " svc-toolbox__category--collapsed" : "") +
                (this.category.empty ? " svc-toolbox__category--empty" : "");
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorToolboxCategory.prototype.getStateElement = function () {
        return this.category;
    };
    SurveyCreatorToolboxCategory.prototype.render = function () {
        var header = this.renderCategoryHeader();
        var items = this.renderCategoryContent();
        return (React.createElement("div", { className: this.class, key: this.category.name },
            React.createElement("div", { className: "svc-toolbox__category-header-wrapper" }, header),
            items));
    };
    SurveyCreatorToolboxCategory.prototype.renderCategoryHeader = function () {
        var _this = this;
        var className = "svc-toolbox__category-header";
        if (this.toolbox.canCollapseCategories) {
            className += " svc-toolbox__category-header--collapsed";
        }
        return attachKey2click(React.createElement("div", { className: className, onClick: function (e) { return _this.category.toggleState(); } },
            React.createElement("span", { className: "svc-toolbox__category-title" }, this.category.title),
            this.renderButton()));
    };
    SurveyCreatorToolboxCategory.prototype.renderButton = function () {
        if (!this.toolbox.canCollapseCategories)
            return null;
        var iconName = this.category.iconName;
        return (React.createElement("div", { className: "svc-toolbox__category-header__controls" },
            React.createElement(SvgIcon, { className: this.category.iconClassName, iconName: iconName, size: "auto" })));
    };
    SurveyCreatorToolboxCategory.prototype.renderCategoryContent = function () {
        return this.renderItems(this.category.items);
    };
    SurveyCreatorToolboxCategory.prototype.renderItems = function (items, isCompact) {
        var _this = this;
        if (isCompact === void 0) { isCompact = false; }
        return items.map(function (item, itemIndex) {
            return React.createElement(SurveyCreatorToolboxTool, { item: item, creator: _this.toolbox.creator, parentModel: _this.toolbox, isCompact: isCompact, key: "item" + itemIndex });
        });
    };
    return SurveyCreatorToolboxCategory;
}(SurveyElementBase));
export { SurveyCreatorToolboxCategory };
ReactElementFactory.Instance.registerElement("svc-toolbox-category", function (props) {
    return React.createElement(SurveyCreatorToolboxCategory, props);
});
